import CloseIcon from "@mui/icons-material/Close";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	IconButton,
	Typography,
	useMediaQuery,
	useTheme
} from "@mui/material";
import { ReactNode } from "react";

interface FilterDialogProps {
	open: boolean;
	onClose: () => void;
	onReset: () => void;
	onSubmit: () => void;
	children: ReactNode;
}

export default function FilterDialog({
	open,
	onClose,
	onReset,
	onSubmit,
	children
}: FilterDialogProps) {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

	return (
		<Dialog open={open} onClose={onClose} fullScreen={isSmallScreen} fullWidth maxWidth="xs">
			<DialogTitle
				sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}
			>
				<Typography variant="text20Bold">Filters</Typography>
				<IconButton size="small" onClick={onClose}>
					<CloseIcon fontSize="small" sx={{ color: "secondary.main" }} />
				</IconButton>
			</DialogTitle>
			<Divider />
			<DialogContent sx={{ display: "flex", flexDirection: "column", gap: 3, pt: 2 }}>
				{children}
			</DialogContent>
			<Divider />
			<DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
				<Button
					variant="outlined"
					onClick={onReset}
					fullWidth
					sx={{ textTransform: "none", fontWeight: 700 }}
				>
					Reset
				</Button>
				<Button
					variant="contained"
					onClick={onSubmit}
					fullWidth
					sx={{
						textTransform: "none",
						fontWeight: 700,
						boxShadow: "none",
						"&:hover": { boxShadow: "none" }
					}}
				>
					Submit
				</Button>
			</DialogActions>
		</Dialog>
	);
}
